import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'

import { SalaDeTrofeosService } from '@features/sala-de-trofeos/data/sala-de-trofeos-service/sala-de-trofeos-service'
import { Badge } from '@features/sala-de-trofeos/models'
import { Image } from '@shared/components'

interface Data {
  badge: Badge
}

@Component({
  selector: 'badge-achieved-modal',
  imports: [Image],
  templateUrl: './badge-achieved-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgeAchievedModal {
  dialogRef = inject(DialogRef)
  data: Data = inject(DIALOG_DATA)

  #salaDeTrofeosService = inject(SalaDeTrofeosService)

  background = computed(() => {
    const colors = this.data.badge.colors
    if (colors.length > 1) return `linear-gradient(180deg, ${colors.join(', ')})`
    return colors[0] ?? ''
  })

  /**
   * Close the modal only when the badge was actually registered as seen; otherwise it would
   * pop up again on the next app load.
   */
  async accept() {
    const marked = await this.#salaDeTrofeosService.markBadgeAsSeen(this.data.badge.category)
    if (marked) this.dialogRef.close()
  }
}
